import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { loginState, userLoginStateConfirmedPromise } from '../cross-app-frontend/firebase';
import { facilitiesRefresh } from '../cross-app-frontend/facilities';
import { errorModalShowStandard } from '../cross-app-frontend/errors';
import { chemicalsRefresh } from '@/services/chemicals';
import { youRefresh } from '../cross-app-frontend/users';

userLoginStateConfirmedPromise
  .then(async () => {
    if (loginState.value === 'logged-in') {
      await Promise.all([facilitiesRefresh(), chemicalsRefresh(), youRefresh()]);
    }
    const app = createApp(App);
    app.use(router);
    app.mount('#app');
  })
  .catch((e) => {
    console.error('Error thrown during app startup:', e);
    errorModalShowStandard(e, 'App startup');
  });
